// @ts-nocheck
import React from 'react';
import { Calendar, CheckCircle, ThumbsUp } from 'lucide-react';

import { NamedLink } from '../../../components';
import { Badge } from '../../../components/ui/badge';

interface ScheduleSectionProps {
  sectionId: string;
  sectionData?: any[];
  [key: string]: any;
}

const featureItems = [
  "See all activities that fit your schedule",
  "Weekly and calendar view options",
  "Automatic conflict detection",
  "Commute time estimation",
];

const ScheduleSection: React.FC<ScheduleSectionProps> = ({ sectionId, sectionData, ...extraProps }) => {
  return (
    <section id={sectionId} className="bg-blue-50 dark:bg-blue-950/20 border-y">
      <div className="container px-4 md:px-6 py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          <div className="space-y-6">
            <p className="font-bold text-destructive text-sm tracking-wide uppercase">Schedule Mode</p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold">
              Build Your Perfect{" "}
              <span className="text-primary underline underline-offset-4">Weekly</span>{" "}
              Schedule
            </h2>
            <p className="text-muted-foreground text-lg font-medium max-w-lg">
              Set your family's availability once, and our Schedule Mode shows you
              only the activities that actually fit. No more juggling spreadsheets
              or missed classes.
            </p>
            <ul className="flex flex-col gap-3">
              {featureItems.map((item) => (
                <li key={item} className="flex items-center gap-2">
                  <CheckCircle className="h-5 w-5 text-primary shrink-0" />
                  <span className="font-medium">{item}</span>
                </li>
              ))}
            </ul>
            <div className="flex flex-wrap gap-4 pt-4">
              <NamedLink name="SchedulePage">
                <span className="servibe-btn servibe-btn-primary inline-flex items-center gap-2 px-8 py-3.5 text-base" data-testid="button-schedule-cta">
                  <span className="flex items-center gap-2">
                    <Calendar className="h-5 w-5" />
                    Try Schedule Mode
                  </span>
                </span>
              </NamedLink>
              <NamedLink name="SearchPage">
                <span className="servibe-btn servibe-btn-secondary inline-flex items-center gap-2 px-8 py-3.5 text-base" data-testid="button-browse-cta">
                  <span>Browse All Activities</span>
                </span>
              </NamedLink>
            </div>
          </div>
          <div className="relative hidden lg:block">
            <div className="rounded-2xl bg-background border p-6 box-shadow-float">
              <div className="flex items-center justify-between mb-6">
                <h3 className="font-bold text-lg">Weekly Schedule</h3>
                <Badge variant="secondary" className="font-medium">Sample</Badge>
              </div>
              <div className="grid grid-cols-5 gap-2 text-center">
                {["Mon", "Tue", "Wed", "Thu", "Fri"].map((day) => (
                  <div key={day} className="text-xs font-bold text-muted-foreground uppercase mb-2">{day}</div>
                ))}
                <div className="rounded-lg bg-primary/10 p-2 text-xs font-medium text-primary">Soccer 4pm</div>
                <div className="rounded-lg bg-emerald-100 dark:bg-emerald-900/30 p-2 text-xs font-medium text-emerald-700 dark:text-emerald-400">Art 3pm</div>
                <div className="rounded-lg bg-violet-100 dark:bg-violet-900/30 p-2 text-xs font-medium text-violet-700 dark:text-violet-400">Music 4pm</div>
                <div className="rounded-lg bg-orange-100 dark:bg-orange-900/30 p-2 text-xs font-medium text-orange-700 dark:text-orange-400">STEM 3pm</div>
                <div className="rounded-lg bg-primary/10 p-2 text-xs font-medium text-primary">Soccer 4pm</div>
              </div>
            </div>
            <div className="absolute -bottom-4 -right-4 rounded-2xl bg-accent/20 border border-accent/30 px-6 py-3 box-shadow-float">
              <div className="flex items-center gap-2">
                <ThumbsUp className="h-4 w-4 text-primary" />
                <span className="text-sm font-semibold">No conflicts!</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScheduleSection;
